import React from 'react';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import Toplist from './toplist';
import Test from './test';

import * as S from './styles';

import {
  AdvizedContentFragment,
  AdvizedToplist,
  AdvizedTest,
} from '../../types';

const linkText = {
  AdvizedToplist: 'Expertens topplista',
  AdvizedTest: 'Expertens test',
};

const AdvizedWidget = ({
  selected,
  grid = false,
}: AdvizedContentFragment & { grid: Boolean }) => {
  if (!selected) {
    return null;
  }

  const { url, __typename, expert } = selected;
  return (
    <S.Wrapper grid={grid}>
      <S.Inner href={url}>
        {__typename === 'AdvizedToplist' && (
          <Toplist {...(selected as AdvizedToplist)} />
        )}
        {__typename === 'AdvizedTest' && (
          <Test {...(selected as AdvizedTest)} />
        )}
        <S.Footer>
          <S.Avatar src={expert.avatar} />
          <span>{linkText[__typename]}</span>
          <ChevronRight />
        </S.Footer>
      </S.Inner>
    </S.Wrapper>
  );
};

export default AdvizedWidget;
